/**
 * Web twin of FilePhoneIcon.tsx (a DOM <svg>; react-native-svg is not used in
 * .web.tsx files). Same path data: the document-with-handset glyph from the
 * design repo's share-action-icons.js.
 */
export const FILE_PHONE_ICON_VIEWBOX = '0 0 24 24';
export const FILE_PHONE_ICON_PATHS = [
  'M4 10V4a2 2 0 0 1 2-2h8l6 6v12a2 2 0 0 1-2 2h-3',
  'M14 2v5a1 1 0 0 0 1 1h5',
  'M3 13h2l1 3-1.2 1.2a8 8 0 0 0 2.8 2.8L8.8 19l3 1v2h-1A10 10 0 0 1 1 13z',
] as const;

interface FilePhoneIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number;
}

export function FilePhoneIcon({ size = 24, color = 'currentColor', strokeWidth = 1.8 }: FilePhoneIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox={FILE_PHONE_ICON_VIEWBOX}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      focusable="false"
    >
      {FILE_PHONE_ICON_PATHS.map((d) => (
        <path
          key={d}
          d={d}
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ))}
    </svg>
  );
}
